import {
  isSmartelds,
  isUnity,
  isEldBooks,
  isBluehorse,
  isVulcansols,
  isRadical,
  isApex,
  isRoadwise,
  isEldNN,
  isE247
} from "../configureStore";

import {
  LOGO_SM,
  LOGO_UNITY,
  LOGO_EB,
  SM_LOGO_BH,
  LOGO_VS,
  LOGO_RE,
  LOGO_AU,
  LOGO_RW,
  LOGO_NN,
  LOGO_E247
} from "../utils/logos";

let htmlHeadDefault = {
  favicon: "/favicon-reseller.ico",
  title: "ELD",
  description: "FMCSA Registered ELD Solution",
  author: "ELD",
  keyword: "ELD, FMCSA, IFTA, HOS, Tracking",
};

let htmlHeadSe = {
  favicon: "/favicon.ico",
  title: "Smartelds",
  description: "FMCSA Registered ELD Solution",
  author: "Asritsolutions LLC",
  keyword: "ELD, Smartelds, FMCSA, IFTA, HOS, Tracking",
};

let htmlHeadUnity = {
  favicon: "/favicon-unity.ico",
  title: "Motioneld",
  description: "FMCSA Registered ELD Solution",
  author: "Unity Eld LLC",
  keyword: "ELD, Motion, Unity, FMCSA, IFTA, HOS, Tracking",
};

let htmlHeadEb = {
  favicon: "/favicon-eldbooks.ico",
  title: "Eldbooks",
  description: "FMCSA Registered ELD Solution",
  author: "Unity Eld LLC",
  keyword: "ELD, FMCSA, IFTA, HOS, Tracking",
};

let htmlHeadBh = {
  favicon: "/favicon-bluehorse.ico",
  title: "Bluehorse",
  description: "FMCSA Registered ELD Solution",
  author: "Blue horse ELD Inc",
  keyword: "ELD, FMCSA, IFTA, HOS, Tracking",
};

let htmlHeadVs = {
  favicon: "/favicon-vulcansols.ico",
  title: "Vulcansols",
  description: "FMCSA Registered ELD Solution",
  author: "Blue horse ELD Inc",
  keyword: "ELD, FMCSA, IFTA, HOS, Tracking",
};

let htmlHeadRe = {
  favicon: "/favicon-radical.ico",
  title: "Radical",
  description: "FMCSA Registered ELD Solution",
  author: "Radical ELD LLC",
  keyword: "ELD, FMCSA, IFTA, HOS, Tracking",
};

let htmlHeadAu = {
  favicon: "/favicon-apex.ico",
  title: "Apex Ultima",
  description: "FMCSA Registered ELD Solution",
  author: "Apex ELD LLC",
  keyword: "ELD, FMCSA, IFTA, HOS, Tracking",
};
let htmlHeadRw = {
  favicon: "/favicon-roadwise.ico",
  title: "Roadwise ELD",
  description: "FMCSA Registered ELD Solution",
  author: "Roadwise ELD LLC",
  keyword: "ELD, FMCSA, IFTA, HOS, Tracking",
};
let htmlHeadNN = {
  favicon: "/favicon-eld99.ico",
  title: "Eld99",
  description: "FMCSA Registered ELD Solution",
  author: "FireFly Systems LLC",
  keyword: "ELD, FMCSA, IFTA, HOS, Tracking",
};
let htmlHeadE247 = {
  favicon: "/favicon-eld247.ico",
  title: "Eld247",
  description: "FMCSA Registered ELD Solution",
  author: "Eld 247 Inc ",
  keyword: "ELD, FMCSA, IFTA, HOS, Tracking",
};


const smarteldsAdminConfig = {
  payments: true,
  reseller: true,
  settings: true,
};
const unityAdminConfig = {
  payments: false,
  reseller: false,
  settings: true,
};
const eldBooksAdminConfig = {
  payments: true,
  reseller: true,
  settings: true,
};
const bluehorseAdminConfig = {
  payments: false,
  reseller: false,
  settings: true,
};
const vulcansolsAdminConfig = {
  payments: false,
  reseller: false,
  settings: true,
};
const radicalAdminConfig = {
  payments: false,
  reseller: false,
  settings: false,
};
const apexAdminConfig = {
  payments: false,
  reseller: true,
  settings: true,
};
const roadwiseAdminConfig = {
  payments: false,
  reseller: true,
  settings: true,
};
const eldNNAdminConfig = {
  payments: false,
  reseller: true,
  settings: true,
};
const eld247AdminConfig = {
  payments: false,
  reseller: true,
  settings: true,
};


const smarteldsNavConfig = {
  settings: true,
  reseller: true,
};
const unityNavConfig = {
  settings: false,
  reseller: false,
};
const eldBooksNavConfig = {
  settings: false,
  reseller: true,
};
const bluehorseNavConfig = {
  settings: false,
  reseller: false,
};
const vulcansolsNavConfig = {
  settings: false,
  reseller: false,
};
const radicalNavConfig = {
  settings: false,
  reseller: false,
};
const apexNavConfig = {
  settings: false,
  reseller: true,
};
const roadwiseNavConfig = {
  settings: false,
  reseller: false,
};
const eldNNNavConfig = {
  settings: false,
  reseller: false,
};
const eld247NavConfig = {
  settings: false,
  reseller: false,
};

export const APP_STYLE_ID = isSmartelds
  ? "app-smartelds"
  : isUnity
  ? "app-unity"
  : isEldBooks
  ? "app-eldbooks"
  : isBluehorse
  ? "app-bluehorse"
  : isVulcansols
  ? "app-vulcansols"
  : isRadical
  ? "app-radical"
  : isApex
  ? "app-apex"
  : isRoadwise
  ? "app-roadwise"
  : isEldNN
  ? "app-eld99"
  : "";
export const HTML_HEAD = isSmartelds
  ? htmlHeadSe
  : isUnity
  ? htmlHeadUnity
  : isEldBooks
  ? htmlHeadEb
  : isBluehorse
  ? htmlHeadBh
  : isVulcansols
  ? htmlHeadVs
  : isRadical
  ? htmlHeadRe
  : isApex
  ? htmlHeadAu
  : isRoadwise
  ? htmlHeadRw
  : isEldNN
  ? htmlHeadNN
  : isE247
  ? htmlHeadE247
  : htmlHeadDefault;

export const LOGO_URL = isSmartelds
  ? LOGO_SM
  : isUnity
  ? LOGO_UNITY
  : isEldBooks
  ? LOGO_EB
  : isBluehorse
  ? SM_LOGO_BH
  : isVulcansols
  ? LOGO_VS
  : isRadical
  ? LOGO_RE
  : isApex
  ? LOGO_AU
  : isRoadwise
  ? LOGO_RW
  : isEldNN
  ? LOGO_NN
  : isE247
  ? LOGO_E247
  : "";

export const LOGIN_ADS = isSmartelds
  ? true
  : isUnity
  ? false
  : isEldBooks
  ? false
  : isBluehorse
  ? false
  : isVulcansols
  ? false
  : isRadical
  ? false
  : isApex
  ? false
  : isRoadwise
  ? false
  : isEldNN
  ? false
  : isE247
  ? false
  : false;

export const ADMIN_CONFIG = isSmartelds
  ? smarteldsAdminConfig
  : isUnity
  ? unityAdminConfig
  : isEldBooks
  ? eldBooksAdminConfig
  : isBluehorse
  ? bluehorseAdminConfig
  : isVulcansols
  ? vulcansolsAdminConfig
  : isRadical
  ? radicalAdminConfig
  : isApex
  ? apexAdminConfig
  : isRoadwise
  ? roadwiseAdminConfig
  : isEldNN
  ? eldNNAdminConfig
  : isE247
  ? eld247AdminConfig
  : smarteldsAdminConfig;

export const NAV_CONFIG = isSmartelds
  ? smarteldsNavConfig
  : isUnity
  ? unityNavConfig
  : isEldBooks
  ? eldBooksNavConfig
  : isBluehorse
  ? bluehorseNavConfig
  : isVulcansols
  ? vulcansolsNavConfig
  : isRadical
  ? radicalNavConfig
  : isApex
  ? apexNavConfig
  : isRoadwise
  ? roadwiseNavConfig
  : isEldNN
  ? eldNNNavConfig
  : isE247
  ? eld247NavConfig
  : smarteldsNavConfig;

export const LOGO_WIDTH = isSmartelds
  ? 150
  : isUnity
  ? 250
  : isEldBooks
  ? 150
  : isBluehorse
  ? 150
  : isVulcansols
  ? 150
  : isRadical
  ? 100
  : isApex
  ? 100
  : isRoadwise
  ? 100
  : isEldNN
  ? 100
  : isE247
  ? 100
  : 150;
